export const emptycheckFields = {
    reUpload:[
        { fieldname: "selectedFile", type: "value", dependencyField: "filePickUp", dependencyValues: ["Local"],label:"File" },
        { fieldname: "adlsList", type: "value", dependencyField: "filePickUp", dependencyValues: ["ADLS"],label:"ADLS Account" },
        { fieldname: "adlsDirectoryForm", type: "value", dependencyField: "filePickUp", dependencyValues: ["ADLS"],label:"Directory" },
        { fieldname: "adlsFileName", type: "value", dependencyField: "filePickUp", dependencyValues: ["ADLS"],label:"File" }
    
    ],
    newAsset: [
        { fieldname: "subDomain", type: "value", dependencyField: null,label:"Sub Domain" },
        { fieldname: "dataAssetOwner", type: "value", dependencyField: null,label:"Data Asset Owner" },
        { fieldname: "assestName", type: "value", dependencyField: null,label:"Asset Name" },
        { fieldname: "dataSteward", type: "value", dependencyField: null,label:"Data Steward" },
        { fieldname: "domain", type: "value", dependencyField: null,label:"Domain" },
        { fieldname: "country", type: "value", dependencyField:null,label:"Market" },
        { fieldname: "region", type: "value", dependencyField:null,label:"Cluster" },
        //{ fieldname: "filePickUp", type: "value", dependencyField:null},
        { fieldname: "selectedFile", type: "value", dependencyField: "filePickUp", dependencyValues: ["Local"],label:"File" },
        { fieldname: "adlsList", type: "value", dependencyField: "filePickUp", dependencyValues: ["ADLS"],label:"ADLS Account" },
        { fieldname: "adlsDirectoryForm", type: "value", dependencyField: "filePickUp", dependencyValues: ["ADLS"],label:"Directory" },
        { fieldname: "adlsFileName", type: "value", dependencyField: "filePickUp", dependencyValues: ["ADLS"],label:"File" }
    ],
    newColumnRule: [
        { fieldname: "addColumns", type: "value", dependencyField: null,label:"Column" },
        { fieldname: "ruleName", type: "value", dependencyField: null,label:"Rule Name" },
        { fieldname: "dimension", type: "value", dependencyField: null,label:"Dimension" },
        { fieldname: "check_type", type: "value", dependencyField: null,label:"Check" },
    ],
    newAssetRule:[
        { fieldname: "dimension", type: "value", dependencyField: null,label:"Dimension" },
        { fieldname: "check_type", type: "value", dependencyField: null,label:"Check" },
 
    ],
    newAlert: [
        { fieldname: "alert_type", type: "value", dependencyField: null,label:"Alert Type" },
        { fieldname: "email", type: "value", dependencyField: "alert_type", dependencyValues: ["Email"],label:"Email" },
        { fieldname: "channel_name", type: "value", dependencyField: "alert_type", dependencyValues: ["Teams"],label:"Channel Name" },
        { fieldname: "weebhook_link", type: "value", dependencyField: "alert_type", dependencyValues: ["Teams"],label:"Weebhook Link" },
    ],



}